module.exports = __webpack_public_path__ + "static/media/Timer_displayed_screen@3x.d8729bbd.png";